import _ from 'lodash'
export default {
  populate (template, params) {
    _.forEach(_.keys(template), function (key) {
      if (_.has(params, key)) {
        template[key] = params[key]
      }
    })
    return template
  }
}
